import { Link } from "react-router-dom";
import constants from "../constants/constants";


export default function Tools() {
  return (
    <section
      className="py-16 relative"
      style={{ backgroundColor: constants.RURAL_COLORS.background }}
    >
      <div
        className="grid md:grid-cols-3 gap-12 max-w-[90vw] mx-auto p-10 mb-10 relative z-10"
        style={{
          border: constants.RURAL_BORDERS.double,
          borderRadius: "18px",
          boxShadow: constants.RURAL_BORDERS.shadow,
          background: "rgba(255,255,255,0.85)",
        }}
      >
        {constants.tools.map((tool) => (
          <Link key={tool.href} to={tool.href} className="group">
            <div
              className="relative flex flex-row h-72 md:h-80 w-full overflow-hidden rounded-xl shadow-md border-4 transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-2xl"
              style={{
                border: constants.RURAL_BORDERS.double,
                background: constants.RURAL_COLORS.accent,
                boxShadow: constants.RURAL_BORDERS.shadow,
                borderRadius: "14px",
              }}
            >
              {/* Background Image */}
              <div className="absolute inset-0 w-full h-full z-0">
                <img
                  src={tool.image}
                  alt={tool.alt}
                  className="object-cover w-full h-full transition-all duration-300 group-hover:brightness-110 group-hover:scale-105"
                  style={{ borderRadius: "14px" }}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
                {/* Gradient overlay on right */}
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(to right, rgba(255,255,255,0.05) 20%, rgba(255,255,255,0.92) 40%)",
                    borderRadius: "14px",
                  }}
                />
              </div>
              {/* Content on right */}
              <div className="relative z-10 flex flex-col justify-center items-start h-full w-3/5 ml-auto pr-8 pl-4">
                <h3
                  className="text-2xl md:text-3xl font-mont font-bold mb-2"
                  style={{ color: constants.RURAL_COLORS.primary }}
                >
                  {tool.title}
                </h3>
                <span
                  className="font-mont text-base md:text-lg"
                  style={{ color: constants.RURAL_COLORS.dark }}
                >
                  {tool.subtitle}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
